// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common.css' /*全局样式*/
import '@/common/lib/iconfont/iconfont.css' /*iconfont*/
import App from './App'
import router from './router.js'
import CommonHeader from '@/components/common-header'
import CommonNav from '@/components/common-nav'
import MyBscroll from '@/components/my-bscroll'
import appTool from './common/appTool'
//import mock from './common/mock'/*模拟接口*/
//mock.bootstrap()
import fetch from './common/fetch'/*接口工具*/
import * as filters from './common/filters' /*vue过滤器*/

/* 报表组件 v-charts（请选择按需加载）
    --完整加载
    import VCharts from 'v-charts'
    Vue.use(VCharts)
    --按需加载
    import VeLine from 'v-charts/lib/line'
    Vue.component(VeLine.name, VeLine)
*/

/* 报表组件 echarts（请选择按需加载）
    --完整加载
    import echarts from 'echarts'
    Vue.prototype.$echarts = echarts
    --按需加载
    import echarts from 'echarts/lib/echarts'
    import 'echarts/lib/chart/bar'
    import 'echarts/lib/component/legend'
    Vue.prototype.$echarts = echarts
*/

Vue.use(ElementUI)
Vue.use(appTool)
Vue.use(fetch)
Vue.config.productionTip = false

/* 注册全局组件 */
Vue.component('common-header', CommonHeader)
Vue.component('common-nav', CommonNav)
Vue.component('my-bscroll', MyBscroll)

/* 路由拦截 */
const whiteList = ['/login']; // 访问白名单
router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        appTool.isLogin() ? next({path: '/'}) : next();
    }
    else {
        if (!appTool.isLogin() && !whiteList.includes(to.path)) {
            next({path: '/login'})
        }
        else {
            next()
        }
    }
});
router.afterEach((to, from) => {
    if(document.querySelector('.my-bscroll-content')){
        document.querySelector('.my-bscroll-content').style.cssText= '' +
            'transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1); ' +
            'transition-duration: 300ms; ' +
            'transform: translate(0px, 0px) scale(1) translateZ(0px);'
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js